import { render } from "./Proportionweather.vue?vue&type=template&id=0c2f7856"
import script from "./Proportionweather.vue?vue&type=script&lang=js"
export * from "./Proportionweather.vue?vue&type=script&lang=js"

import "./Proportionweather.vue?vue&type=style&index=0&id=0c2f7856&lang=css"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__